import {createSelector} from "reselect";
import {getUserAchievementsRequestStates} from "modules/selectors";

export const getIsLoadingAchievements = createSelector(
	getUserAchievementsRequestStates,
	({isComplete}) => !isComplete
);
